<template>
  <div class="round-up-for-charity">
    <div v-if="!isConfirmation && !readOnly" class="round-up-for-charity__edit">
      <div class="iw-body-text-small round-up-for-charity__item">
        <div class="round-up-for-charity__item">
          <app-checkbox :model-value="['true']" :payload="getRoundUpForCharity" @update:modelValue="onRoundUpChange">
            <p class="iw-body-text-large round-up-for-charity__label">{{ charityRoundingTypeTitle }}</p>
          </app-checkbox>
        </div>
        <p
          class="round-up-for-charity__amount"
          :class="{ 'round-up-for-charity__light-text': !getRoundUpForCharity }"
          :aria-disabled="!getRoundUpForCharity"
        >
          {{ prependUsdSign(getRoundUpForCharityAmount) }}
        </p>
      </div>
      <div v-if="charityRoundingTypeMessage" class="round-up-for-charity__message">
        {{ charityRoundingTypeMessage }}
      </div>
    </div>
    <div v-else-if="getRoundUpForCharity || checkoutRoundUpForCharity" class="round-up-for-charity__confirmation">
      <div class="iw-body-text-small round-up-for-charity__item">
        <p>{{ charityRoundingTypeTitle }}</p>
        <p>{{ prependUsdSign(getCheckoutParams.roundUpAmount) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AppCheckbox from "../../../../../components/base/app-checkbox/AppCheckbox.vue";
import { prependUsdSign } from "@/utils";

export default {
  name: "RoundUpForCharity",
  components: {
    AppCheckbox
  },
  props: {
    isConfirmation: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      getRoundUpForCharityAmount: "cart/getRoundUpForCharityAmount",
      getRoundUpForCharity: "cart/getRoundUpForCharity",
      activeVendor: "vendor/getActiveVendor",
      getCheckoutParams: "cart/getCheckoutParams"
    }),
    charityRoundingTypeTitle() {
      return this.activeVendor?.charityRoundingType.title || "Round-up for charity";
    },
    charityRoundingTypeMessage() {
      return this.activeVendor?.charityRoundingType.message;
    },
    checkoutRoundUpForCharity() {
      return !!this.getCheckoutParams?.roundUpForCharity;
    }
  },
  methods: {
    ...mapActions({
      setRoundUpForCharity: "cart/setRoundUpForCharity",
      validateCart: "cart/validateCart"
    }),
    onRoundUpChange() {
      this.setRoundUpForCharity(!this.getRoundUpForCharity);
      this.validateCart();
    },
    prependUsdSign
  }
};
</script>

<style scoped lang="scss">
.round-up-for-charity {
  &__edit {
    margin: 21px 0 25px;
    p {
      line-height: 19px;
      margin-top: 3px;
      margin-bottom: 4px;
    }
  }
  &__confirmation {
    margin-top: 15px;
    margin-bottom: 7px;
    p {
      height: 20px;
      margin: 0px;
    }
  }
  &__label {
    margin-left: 36px;
  }
  &__message {
    margin-left: 36px;
    margin-top: 11px;
    color: $group-3-color-3;
  }
  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: none;
    font-weight: normal;
  }
  &__light-text {
    color: $group-3-color-3-alpha-40;
  }
}
</style>
